export type normalizeChatTextProps = (text?: string) => string;

export const normalizeChatText: normalizeChatTextProps = (text = '') =>
  text?.replace(/^@ref_{[\w\d-]*} /, '');
